import microRequest from "@/utils/microSeviceFormatRequest";

/** Vue2 dashboard.js uses microSeviceFormatRequest → returns Body */

export function getTutorHomeTask() {
  return microRequest({
    url: "/api/GrowthSystem/GetTutorHomeTask",
    method: "post",
  });
}

export function getGradeHonorDetail() {
  return microRequest({
    url: "/api/GrowthSystem/GetGradeHonorDetail",
    method: "post",
  });
}

export function receivePoint(TaskCode) {
  return microRequest({
    url: `/api/GrowthSystem/ReceivePoint?TaskCode=${TaskCode}`,
    method: "post",
  });
}

export function growthSystemIsFirstLogin() {
  return microRequest({
    url: "/api/GrowthSystem/GrowthSystemIsFirstLogin",
    method: "post",
  });
}

export function growthSystemDoTask(TaskCode) {
  return microRequest({
    url: `/api/GrowthSystem/DoTaskAsync?TaskCode=${TaskCode}`,
    method: "post",
  });
}

export function getGrowthDetail(pageIndex, pageSize) {
  return microRequest({
    url:
      "/api/GrowthSystem/GetGrowthDetail?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

export function getCourseLearning() {
  return microRequest({
    url: "/api/GrowthSystem/GetCourseLearning",
    method: "post",
  });
}

export function subscriptionCourse(isCheckCourseTest, isCheckVideoTrain) {
  return microRequest({
    url:
      "/api/GrowthSystem/SubscriptionCourse?isCheckCourseTest=" +
      isCheckCourseTest +
      "&isCheckVideoTrain=" +
      isCheckVideoTrain,
    method: "post",
  });
}

export function getGrowthPonitRanking(pageIndex, pageSize) {
  return microRequest({
    url:
      "/api/GrowthSystem/GetGrowthPonitRanking?pageIndex=" +
      pageIndex +
      "&pageSize=" +
      pageSize,
    method: "post",
  });
}

export function medalLog(code, type) {
  return microRequest({
    url: `/api/GrowthSystem/TaskLog?code=${code}&type=${type}`,
    method: "post",
  });
}

export function getTuGrowthRank() {
  return microRequest({
    url: "/api/GrowthSystem/GetTuGrowthRank",
    method: "post",
  });
}

export function receviceMadal(MadalType) {
  return microRequest({
    url: `/api/GrowthSystem/ReceviceMadal?MadalType=${MadalType}`,
    method: "post",
  });
}

export function getTutorRights(level) {
  return microRequest({
    url: `/api/GrowthSystem/GetTutorRights?level=${level}`,
    method: "post",
  });
}

export function receiveRights(rightsCode) {
  return microRequest({
    url: `/api/GrowthSystem/ReceiveRights?rightsCode=${rightsCode}`,
    method: "post",
  });
}

export function tutorRightsRecode() {
  return microRequest({
    url: `/api/GrowthSystem/TutorRightsRecode`,
    method: "post",
  });
}

export function levelMedalList() {
  return microRequest({
    url: `/api/GrowthSystem/LevelMedalList`,
    method: "post",
  });
}

export function taskStartSubmit() {
  return microRequest({
    url: `/api/GrowthSystem/TaskStartSubmit`,
    method: "post",
  });
}

export function getRightsList() {
  return microRequest({
    url: `/api/GrowthSystem/GetRightsList`,
    method: "post",
  });
}

export function getMilestoneList() {
  return microRequest({
    url: `/api/GrowthSystem/GetMilestoneList`,
    method: "post",
  });
}

export function getMilestoneDetail(type) {
  return microRequest({
    url: `/api/GrowthSystem/GetMilestoneDetail?type=${type}`,
    method: "post",
  });
}

export function isPassTL() {
  return microRequest({
    url: `/api/GrowthSystem/IsPassTL`,
    method: "post",
  });
}

export function getReceiveRecordToDay() {
  return microRequest({
    url: `/api/GrowthSystem/GetReceiveRecordToDay`,
    method: "post",
  });
}

export function getStrengthAssessment(isShowCycle, date) {
  return microRequest({
    url: `/api/GrowthSystem/GetStrengthAssessment?isShowCycle=${isShowCycle}&date=${date}`,
    method: "post",
  });
}

export function getScheduleList() {
  return microRequest({
    url: `/api/GrowthSystem/GetScheduleList`,
    method: "post",
  });
}

export function scheduleSubmit(data) {
  return microRequest({
    url: `/api/GrowthSystem/ScheduleSubmit`,
    method: "post",
    data,
  });
}

export function getPetInfo() {
  return microRequest({
    url: `/api/GrowthSystem/GetPetInfo`,
    method: "post",
  });
}

export function adoptPet() {
  return microRequest({
    url: `/api/GrowthSystem/AdoptPet`,
    method: "post",
  });
}

export function getLimitedTimeMedal() {
  return microRequest({
    url: `/api/GrowthSystem/GetLimitedTimeMedal`,
    method: "post",
  });
}

export function alterPetName(petName) {
  return microRequest({
    url: `/api/GrowthSystem/AlterPetName?petName=${petName}`,
    method: "post",
  });
}

export function classGroupPhotoSubmit(data) {
  return microRequest({
    url: `/api/GrowthSystem/ClassGroupPhotoSubmit`,
    method: "post",
    data,
  });
}

export function wearMedal(code) {
  return microRequest({
    url: `/api/GrowthSystem/WearMedal?code=${code}`,
    method: "post",
  });
}

export function getCertificationMedals() {
  return microRequest({
    url: `/api/GrowthSystem/GetCertificationMedals`,
    method: "post",
  });
}

export function requestLog(data) {
  return microRequest({
    url: `/api/GrowthSystem/RequestLog`,
    method: "post",
    data,
  });
}

export function updateLogTime(data) {
  return microRequest({
    url: `/api/GrowthSystem/UpdateLogTime`,
    method: "post",
    data,
  });
}

export function getPhotoSharing() {
  return microRequest({
    url: `/api/GrowthSystem/GetPhotoSharing`,
    method: "post",
  });
}

export function getGoalList() {
  return microRequest({
    url: `/api/GrowthSystem/GetGoalList`,
    method: "post",
  });
}

export function getGoalByRound() {
  return microRequest({
    url: `/api/GrowthSystem/GetGoalByRound`,
    method: "post",
  });
}

export function addGoal(data) {
  return microRequest({
    url: `/api/GrowthSystem/AddGoal`,
    method: "post",
    data,
  });
}

export function deleteGoal(id) {
  return microRequest({
    url: `/api/GrowthSystem/DeleteGoal?id=${id}`,
    method: "post",
  });
}

export function updateGoal(id, target) {
  return microRequest({
    url: `/api/GrowthSystem/UpdateGoal?id=${id}&target=${target}`,
    method: "post",
  });
}

export function synchronizeGoalBasicWage(id) {
  return microRequest({
    url: `/api/GrowthSystem/SynchronizeGoalBasicWage?id=${id}`,
    method: "post",
  });
}

export function getReceiveByCourse() {
  return microRequest({
    url: `/api/GrowthSystem/GetReceiveByCourse`,
    method: "post",
  });
}

export function receivePointByCourse(id, type) {
  return microRequest({
    url: `/api/GrowthSystem/ReceivePointByCourse?id=${id}&type=${type}`,
    method: "post",
  });
}

export function getPetGifByLevel(level) {
  return microRequest({
    url: `/api/GrowthSystem/GetPetGifByLevel?level=${level}`,
    method: "post",
  });
}

export function getTutorHaveSkin(level) {
  return microRequest({
    url: `/api/GrowthSystem/GetTutorHaveSkin?level=${level}`,
    method: "post",
  });
}

export function wearPetClothing(id, isDefault) {
  return microRequest({
    url: `/api/GrowthSystem/WearPetClothing?id=${id}&isDefault=${isDefault}`,
    method: "post",
  });
}

export function ReceivePetClothing(level) {
  return microRequest({
    url: `/api/GrowthSystem/ReceivePetClothing?level=${level}`,
    method: "post",
  });
}

/** Trial Class Report — Body unwrapped */
export function getTraiClass() {
  return microRequest({
    timeout: 0,
    url: "/api/tutordata/TraiClass",
    method: "post",
  });
}

/** Bulletin Board — Body unwrapped { Title, Content } */
export function getBulletinBoard() {
  return microRequest({
    url: "/api/Message/BulletinBoard",
    method: "post",
  });
}

/** Key Regulations — Body unwrapped { ModuleDescription, FileContents } */
let keyRegulationsCache = null;
let keyRegulationsPromise = null;
export function getKeyRegulationsPublish() {
  if (keyRegulationsCache) return Promise.resolve(keyRegulationsCache);
  if (keyRegulationsPromise) return keyRegulationsPromise;
  keyRegulationsPromise = microRequest({
    url: "/api/KeyRegulations/GetPublish",
    method: "get",
  })
    .then((res) => {
      keyRegulationsCache = res;
      keyRegulationsPromise = null;
      return res;
    })
    .catch((err) => {
      keyRegulationsPromise = null;
      throw err;
    });
  return keyRegulationsPromise;
}

/** QA Test Report — Body unwrapped { overallScore, chartsData } */
export function getEvaluateList() {
  return microRequest({
    url: "/api/tutordata/EvaluateList",
    method: "post",
  });
}
